import { BrowserSpecs } from '../types';

const isCompatible = ( browserSpecs: BrowserSpecs[] ): boolean => {
    const { userAgent } = window.navigator;

    // Cant use for .. of See: https://stackoverflow.com/questions/500504/why-is-using-for-in-for-array-iteration-a-bad-idea
    for ( let i = 0; i < browserSpecs.length; i += 1 ) {
        const bs = browserSpecs[ i ];

        if ( userAgent.match( bs.browserTypeRegex ) ) {
            const browserVersion = userAgent.match( bs.browserVersionRegex );

            if ( browserVersion && browserVersion.length >= 2 ) return parseInt( browserVersion[ 1 ], 10 ) >= bs.minimumExpectedVersion;

            // Break early in case of the match of version goes wrong
            return false;
        }
    }
    return false;
};

// ADA is only compatible with a certain set of browsers (See: https://docs.ada.cx/docs/scripted/before-you-begin/determine-browser-compatibility/#ada-web-chat--desktop)
export const ADA_MINIMUM_SPECS: BrowserSpecs[] = [
    {
        browserTypeRegex: /Edg\//,
        browserVersionRegex: /Edg\/(\d+)/,
        minimumExpectedVersion: 99,
    },
    {
        browserTypeRegex: /Chrome\//,
        browserVersionRegex: /Chrome\/(\d+)/,
        minimumExpectedVersion: 99,
    },
    {
        browserTypeRegex: /CriOS\//,
        browserVersionRegex: /CriOS\/(\d+)/,
        minimumExpectedVersion: 99,
    },
    {
        browserTypeRegex: /Firefox\//,
        browserVersionRegex: /Firefox\/(\d+)/,
        minimumExpectedVersion: 75,
    },
    {
        browserTypeRegex: /Safari\//,
        browserVersionRegex: /Version\/(\d+)/,
        minimumExpectedVersion: 14,
    },
];

export default isCompatible;